function requestCCR(memberId) {
  window.open(`/workflow_queues/customer_service_action/${memberId}/member/${memberId}/CUSTSERVE_CCR?description=Request+CCR`, '_blank');
}

export default requestCCR;
